module.exports = __webpack_public_path__ + "static/media/class (6).c9aee4ee.webp";